// Puente para emitir toasts desde fuera de React (ej. el interceptor de axios).
// ToastProvider registra el handler en montaje (setGlobalToastHandler) y lo libera
// al desmontar. Incluye dedupe temporal: el warmup dispara ~12 requests al loguear,
// así que si el backend cae no queremos 12 toasts idénticos.

let handler = null
let lastKey = ''
let lastAt = 0

export function setGlobalToastHandler(fn) {
  handler = fn
}

export function emitGlobalToast(tone, message, { dedupeMs = 4000 } = {}) {
  if (!handler || typeof handler[tone] !== 'function') return
  const key = `${tone}:${message}`
  const now = Date.now()
  if (key === lastKey && now - lastAt < dedupeMs) return
  lastKey = key
  lastAt = now
  try {
    handler[tone](message)
  } catch {
    /* noop: nunca dejar que un fallo de toast rompa el flujo del request */
  }
}
